<template>
  <div class="text-center">
    <v-menu
      class="z-20"
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-y
      left
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on"
          ><v-icon class="!m-0" color="primary">fas fa-user</v-icon></v-btn
        >
      </template>

      <v-card>
        <v-list>
          <v-list-item>
            <v-list-item-avatar>
              <v-avatar color="primary" size="56"><v-icon dark> fas fa-user </v-icon></v-avatar>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{ userName }}</v-list-item-title>
              <v-list-item-subtitle>{{ userEmail }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list>
          <v-list-item v-for="(item, i) in options" :key="i" link>
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content @click="item.action">
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data: () => ({
    menu: false,
  }),
  methods: {
    ...mapActions(["handleLogout"]),
  },
  computed: {
    ...mapGetters(["userName", "userEmail"]),
    options() {
      return [
        {
          text: this.translate("header.userMenu.viewProfile"),
          icon: "fas fa-user-circle",
          action: () => {
            this.$router.push({ name: "profile" }).catch(() => {});
          },
        },
        {
          text: this.translate("header.userMenu.signOut"),
          icon: "fas fa-sign-out",
          action: () => {
            this.handleLogout();
          },
        },
      ];
    },
  },
};
</script>
